export default "__VITE_ASSET__BOjauZ7b__"